import { Injectable } from '@angular/core';
import {
  ApplicationsApiService,
  SnackbarService,
  ProductTypeCatalogApiService,
  OfficesApiService,
  PeopleApiService,
  PeopleLookupApiService,
  CoursesApiService,
  CoursesOnDemandApiService
} from '@tangilla/tg-ng-core';
import { SurveyUtilsService } from '../utils/survey.utils.service';
import { ApplicationForm } from '../utils/application-form';
import { SurveyService } from 'src/app/core/services/survey/survey.service';
import { ErrorsService } from 'src/app/core/services/utils/errors.service';
import { DetailsListWidgetService } from '../../widgets/details-list/services/details-list.widget.service';
import {
  ApplicationChargesUtilsService
} from '../../../../core/services/utils/charges/application-charges.utils.service';
import { OfficesUtilsService } from 'src/app/core/services/utils/offices.utils.service';


@Injectable({
  providedIn: 'root'
})
export class MLSApplicationService extends ApplicationForm {

  override applicationMemberType: string = 'mlsonly';

    constructor(
      override officesApiService: OfficesApiService,
      override applicationsService: ApplicationsApiService,
      override snackbarService: SnackbarService,
      override productTypeCatalogService: ProductTypeCatalogApiService,
      override chargesUtils: SurveyUtilsService,
      override surveyService: SurveyService,
      override peopleApiService: PeopleApiService,
      override peopleLookupService: PeopleLookupApiService,
      override errorsService: ErrorsService,
      override detailsListWidgetService: DetailsListWidgetService,
      override applicationChargesUtilsService: ApplicationChargesUtilsService,
      override coursesOnDemandApiService: CoursesOnDemandApiService,
      override coursesApiService: CoursesApiService,
      protected officesUtilsService: OfficesUtilsService,
    ) {
      super(applicationsService, productTypeCatalogService, snackbarService, chargesUtils, surveyService, peopleApiService, peopleLookupService, errorsService, officesApiService, detailsListWidgetService, applicationChargesUtilsService, coursesOnDemandApiService, coursesApiService);
    }

    override initializeOnCurrentPageChanging() {
      this.surveyService.surveyModel.onCurrentPageChanging.add((sender, options) => {
        if (options.oldCurrentPage !== null) {
          const thisPageName = options.oldCurrentPage.name;
          switch (thisPageName) {
            case 'License Details':
              if(this.surveyService.surveyModel.getValue('LicenseHeld') === 'Yes') {
                this.getAvailableMembershipTypes().subscribe();
              }
              break;
            case 'M1 Validation':
            case 'Your Office':
              // case 'DR Status':
              this.getAvailableMembershipTypes().subscribe();
              break;
          }

        }
      });
    }
    
  override initializeOnAfterRenderPage() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch (currentPage.name) {
        case 'Orientation Session Additional':
          this.loadAdditionalOrientationEvents('Orientation2', this.surveyService.surveyModel.getVariable('additional_orientation_is_on_demand'), this.surveyService.surveyModel.getVariable('additional_course_id'), this.surveyService.surveyModel.getVariable('additional_course_days'));
          break;
        case 'Ethics Orientation Session Additional':
          this.loadAdditionalOrientationEvents('EthicsOrientation', false, this.surveyService.surveyModel.getVariable('additional_ethics_course_id'), this.surveyService.surveyModel.getVariable('additional_ethics_course_days'));
          break;
        case 'Confirmation':
          this.buildOrderConfirmation();
          break;
        case 'Transition Election Confirmation':
          break;
        case 'Membership Type Selection':
          const availableMembershipTypes = this.surveyService.surveyModel.getVariable('available_membership_types');
          if(!availableMembershipTypes || availableMembershipTypes.length === 0) {
            this.surveyService.surveyModel.getPageByName('Membership Type Selection').getQuestionByName('error_message').visible = true;
            this.surveyService.surveyModel.getPageByName('Membership Type Selection').getQuestionByName('error_message')['html'] = '<p><b>There are no available membership types for you to select. Please contact your association for more information.</b></p>';
            this.surveyService.surveyModel.getPageByName('Membership Type Selection').getQuestionByName('MembershipType').description = '';
          } else {
            this.surveyService.surveyModel.getPageByName('Membership Type Selection').getQuestionByName('error_message').visible = false;
            this.surveyService.surveyModel.getPageByName('Membership Type Selection').getQuestionByName('MembershipType').visible = true;
            this.surveyService.surveyModel.getPageByName('Membership Type Selection').getQuestionByName('MembershipType').description = 'Please select from the option below that best describes the type of membership you are applying for.'
          }
          break;
      }
    });
  }

  override initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add((surveyModel, questionThatChanged) => {
      if (questionThatChanged.name === 'DesignatedRealtor') {
        if (questionThatChanged.value) {
          this.getAvailableMembershipTypes().subscribe();
        }
      } else if (questionThatChanged.name === 'application_intention') {
        if (questionThatChanged.value) {
          this.getAvailableMembershipTypes().subscribe();
        }
      }else if (questionThatChanged.name === 'isCorp') {
        this.officesUtilsService.setOfficeNameInSurvey(questionThatChanged.value);
      } else if ( questionThatChanged.name === 'LicenseHeld' ) {
        if (questionThatChanged.value === 'No') {
          this.getAvailableMembershipTypes().subscribe();
        }
      }
    });
  }
}